import CustomUserMenu from "./custom-user-menu";
import {AppBar} from "react-admin";

const CustomAppBar = (props:any) => <AppBar {...props} userMenu={<CustomUserMenu />} />;

export default CustomAppBar;